/**
 * openedTracker — remembers (per browser) when the operator last opened a
 * document for processing, so the queue can show "you opened this" markers.
 */
const STORAGE_KEY = "openedDocs";
const MAX_ENTRIES = 500;

export const markDocumentOpened = (id) => {
  if (!id) return;
  try {
    const map = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    map[id] = Date.now();
    // keep the map bounded
    const ids = Object.keys(map);
    if (ids.length > MAX_ENTRIES) {
      ids
        .sort((a, b) => map[a] - map[b])
        .slice(0, ids.length - MAX_ENTRIES)
        .forEach((staleId) => delete map[staleId]);
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch (err) {
    // storage unavailable: markers simply are not persisted
  }
};

export const getOpenedMap = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch (err) {
    return {};
  }
};

/** Most recently opened document ids for this browser, newest first. */
export const getRecentOpenedEntries = (limit = 5) => {
  const map = getOpenedMap();
  return Object.keys(map)
    .map((id) => ({ id, openedAt: map[id] }))
    .filter((entry) => entry.id && entry.openedAt)
    .sort((a, b) => b.openedAt - a.openedAt)
    .slice(0, limit);
};

export const getLastOpenedId = () => getRecentOpenedEntries(1)[0]?.id || null;
